import React, {Component} from 'react';
import {TableHeader} from './TableHeader';
import {TableBody} from './TableBody';

class Table extends Component{
    render(){
      const {characterData, removeCharacter} = this.props;

      return(
        <table>
            <TableHeader/>
            <TableBody characterData={characterData} 
                       removeCharacter={removeCharacter}
            />
        </table>
      );
    }
}

/*
const SimpleComponent = () => {
    return (<div>Example</div>);
}

class ClassComponent extends Component{
    render(){
        return (<div>Example</div>);
    }
}
*/

export default Table;